<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!--<div class="sf-col sf-col-7">-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<mdj-y-graph-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
		
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<mdj-y-graph-chart ref="graph" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			
			<div class="sf-col sf-col-8">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<mdj-y-graph-table ref="table" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
		
		</div>
	</div>
</template>

<script>
import MdjYGraphSearch from './Search/MdjYGraphSearch.vue';
import MdjYGraphTable from './Table/MdjYGraphTable.vue';
import MdjYGraphChart from './Table/MdjYGraphChart.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { MdjYGraphSearch, MdjYGraphTable, MdjYGraphChart },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
